import { render, staticRenderFns } from "./RouterLinkColumn.vue?vue&type=template&id=848076d4"
import script from "./RouterLinkColumn.vue?vue&type=script&lang=js"
export * from "./RouterLinkColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../frontend-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports